<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
// eslint-disable-next-line no-unused-vars
import NumerosaLetras from "../../../../helpers/numeros";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

/**
 * Products component
 */
// eslint-disable-next-line no-unused-vars
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      logoUrl: (process.env.BASE_URL || "/") + "logo.jpeg",
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        totalPendiente: 0,
        total_adelanto: 0,
        totalPagado: 0,
        vendedor: "",
        total: "",
        state: true,
        id: 0,
      },
      estadoCredito: false,
      formFactura: {
        fecha_emision: "",
        fecha_certificacion: "",
        dataCert: "",
        serie: "",
        number: "",
        uuid: "",
      },
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
      detalleProducto : [],
      detalleServicio :[]
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  updated() {
    this.$refs["buttonImprimir"].click();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    letras(cantidad) {
      let a;
      a = NumerosaLetras(cantidad);
      return a;
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    quantity(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    detalle() {
      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "ordenes/view?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.formPro.totalPendiente = response.data.respuesta.saldo_credito
            this.formPro.totalPagado = (parseFloat(response.data.respuesta.total) - parseFloat(response.data.respuesta.saldo_credito));

          // console.log(response);
          me.formPro.cliente = response.data.respuesta.vehiculo.cliente.persona.nombre_persona
          me.formPro.auto = response.data.respuesta.vehiculo.modelo.auto.nombre_auto;
          me.formPro.modelo = response.data.respuesta.vehiculo.modelo.nombre_modelo;
          me.formPro.placas = response.data.respuesta.vehiculo.placa;
          me.formPro.anio = response.data.respuesta.vehiculo.anio;
          me.formPro.observaciones = response.data.respuesta.observacion_cliente;
          me.formPro.observaciones_mecanico = response.data.respuesta.observacion_mecanico;
          me.formPro.observacion_general = response.data.respuesta.observaciones;
          me.estadoCredito=response.data.respuesta.estado_credito;
          // console.log(response.data.respuesta);
          me.formPro.total = response.data.respuesta.total;
          me.formPro.saldo = response.data.respuesta.saldo_credito;
          me.formPro.fecha_entrada = response.data.respuesta.fecha_entrada;
          me.formPro.fecha_entrada = response.data.respuesta.fecha_entrada;
          me.formPro.no_servicio = response.data.respuesta.no_servicio;
          me.formPro.total_adelanto =( this.sumarPagosTaller(response.data.respuesta.adelantos_tallers));
          // console.log(response.data.respuesta.adelantos_tallers);
          me.detalleProducto = response.data.respuesta.detalle_prod_servs;
          me.detalleServicio = response.data.respuesta.detalle_serv_servs;
          me.formPro.usuario = response.data.respuesta.user.empleado.persona.nombre_persona+' '+response.data.respuesta.user.empleado.persona.apellido_persona;
          me.formPro.sucursal = response.data.respuesta.tienda.nombre_tienda;

        //   console.log(me.detalleProducto, me.detalleServicio);


        });
    },
    sumarPagosTaller(pagos){
      console.log(pagos)
        return pagos.reduce((total, item) => {
          let monto = parseFloat(item.adelanto); // Convierte el valor a número
          if (!isNaN(monto)) { // Verifica si es un número válido
              return total + monto;
          }
          return total;
      }, 0);
    },
    calcularTotal() {
      let total = 0;
      this.detalleServicio.forEach(item => {
        total += item.subtotal_servicio;
      });
      return this.money(total);
    },
    calcularTotalRepuestos() {
      let total = 0;
      this.detalleProducto.forEach(item => {
        total += item.subtotal_venta;
      });
      return this.money(total);
    }
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <!-- Botones (no se imprimen) -->
    <div class="row mt-4 d-print-none">
      <div class="col">
        <router-link
          :to="{ name: 'taller' }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col">
        <div class="float-end">
          <a
            ref="buttonImprimir"
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a>
        </div>
      </div>
    </div>

    <!-- Recibo -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body rt">
            <!-- Header corporativo -->
            <div class="rt-header">
              <div class="rt-brand">
                <img :src="logoUrl" alt="Logo" class="rt-logo" />
                <div>
                  <div class="rt-name">Taller de Reparación Ariel</div>
                  <div class="rt-contact"><i class="bx bx-phone"></i> 4889 9653 · 4477 4533</div>
                  <div class="rt-contact"><i class="bx bx-map"></i> Comapa, Jutiapa</div>
                </div>
              </div>
              <div class="rt-doc">
                <div class="rt-doc-title">ORDEN DE SERVICIO</div>
                <div class="rt-doc-no">No. {{ formPro.no_servicio }}</div>
                <div class="rt-doc-date">Ingreso: {{ formPro.fecha_entrada }}</div>
              </div>
            </div>

            <!-- Cliente / Vehículo -->
            <div class="rt-info">
              <div class="rt-info-col">
                <div class="rt-info-label">Cliente</div>
                <div class="rt-info-value">{{ formPro.cliente }}</div>
              </div>
              <div class="rt-info-col">
                <div class="rt-info-label">Vehículo</div>
                <div class="rt-info-value">{{ formPro.auto }} {{ formPro.modelo }}</div>
                <div class="rt-info-sub">Año {{ formPro.anio }} · Placa {{ formPro.placas }}</div>
              </div>
            </div>

            <!-- Mano de obra -->
            <div class="rt-section">Mano de obra</div>
            <table class="rt-table">
              <thead>
                <tr>
                  <th>Descripción</th>
                  <th class="c">Cantidad</th>
                  <th class="r">Precio unitario</th>
                  <th class="r">Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in detalleServicio" :key="idx">
                  <td>{{ item.servicio.nombre_servicio }}</td>
                  <td class="c">{{ quantity(item.cantidad_servicios) }} Unidad(es)</td>
                  <td class="r">{{ money(item.precio_servicio) }}</td>
                  <td class="r">{{ money(item.subtotal_servicio) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" class="r">Subtotal mano de obra</td>
                  <td class="r">{{ calcularTotal() }}</td>
                </tr>
              </tfoot>
            </table>

            <!-- Repuestos -->
            <div class="rt-section">Repuestos y materiales</div>
            <table class="rt-table">
              <thead>
                <tr>
                  <th>Descripción</th>
                  <th class="c">Cantidad</th>
                  <th class="r">Precio unitario</th>
                  <th class="r">Monto</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in detalleProducto" :key="idx">
                  <td>{{ item.producto.nombre_producto }}</td>
                  <td class="c">{{ quantity(item.cantidad_venta) }} Unidad(es)</td>
                  <td class="r">{{ money(item.precio_venta) }}</td>
                  <td class="r">{{ money(item.subtotal_venta) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" class="r">Subtotal repuestos</td>
                  <td class="r">{{ calcularTotalRepuestos() }}</td>
                </tr>
              </tfoot>
            </table>

            <!-- Totales -->
            <div class="rt-totals">
              <div class="rt-totline">
                <span>Total</span>
                <strong>{{ money(formPro.total > 0 ? formPro.total : 0.0) }}</strong>
              </div>
              <div class="rt-totline">
                <span>Adelanto efectivo</span>
                <strong>{{ money(formPro.total_adelanto) }}</strong>
              </div>
              <div
                class="rt-totline rt-pendiente"
                v-if="estadoCredito && formPro.total_adelanto > 0"
              >
                <span>Pendiente</span>
                <strong>{{ money(parseFloat(formPro.totalPendiente)) }}</strong>
              </div>
              <div
                class="rt-totline rt-pendiente"
                v-if="estadoCredito == false && formPro.total_adelanto > 0"
              >
                <span>Pendiente</span>
                <strong>{{ money(parseFloat(formPro.total) - parseFloat(formPro.total_adelanto)) }}</strong>
              </div>
            </div>

            <div class="rt-letras">
              <strong>Valor en letras:</strong> {{ letras(formPro.total) }}
            </div>

            <p class="rt-nota">
              <strong>IMPORTANTE:</strong> Este presupuesto está sujeto a variaciones de
              precios por diferentes circunstancias que puedan presentarse al momento de
              la reparación.
            </p>

            <div class="rt-footer">
              Gracias por confiar en Taller de Reparación Ariel
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.rt { color: #2b2f3a; font-size: 13px; }

/* Header */
.rt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 4px solid #1b2a4e;
  padding-bottom: 16px;
  margin-bottom: 18px;
}
.rt-brand { display: flex; align-items: center; gap: 16px; }
.rt-logo { height: 80px; width: auto; border-radius: 8px; object-fit: contain; }
.rt-name { font-size: 24px; font-weight: 800; color: #1b2a4e; line-height: 1.1; }
.rt-contact { font-size: 12px; color: #6b7280; margin-top: 2px; }
.rt-doc { text-align: right; }
.rt-doc-title {
  background: #1b2a4e; color: #fff; font-weight: 700; font-size: 14px;
  padding: 6px 16px; border-radius: 4px; letter-spacing: 1px; display: inline-block;
}
.rt-doc-no { font-size: 20px; font-weight: 800; color: #c5a253; margin-top: 6px; }
.rt-doc-date { font-size: 12px; color: #6b7280; }

/* Info cliente */
.rt-info {
  display: flex; gap: 16px;
  background: #f7f9fc; border: 1px solid #e7e9ef; border-radius: 8px;
  padding: 14px 18px; margin-bottom: 18px;
}
.rt-info-col { flex: 1; }
.rt-info-label { font-size: 10px; color: #8a909c; text-transform: uppercase; letter-spacing: .5px; }
.rt-info-value { font-size: 15px; font-weight: 700; color: #1b2a4e; }
.rt-info-sub { font-size: 12px; color: #6b7280; }

/* Secciones */
.rt-section {
  font-size: 14px; font-weight: 700; color: #1b2a4e;
  margin: 18px 0 8px; padding-left: 10px; border-left: 4px solid #c5a253;
}

/* Tablas */
.rt-table { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
.rt-table thead th {
  background: #1b2a4e; color: #fff; font-size: 11px; font-weight: 600;
  text-transform: uppercase; padding: 9px 10px; text-align: left;
}
.rt-table tbody td { padding: 8px 10px; border-bottom: 1px solid #eef0f4; font-size: 12px; }
.rt-table tbody tr:nth-child(even) { background: #f9fafc; }
.rt-table tfoot td {
  padding: 9px 10px; font-weight: 700; color: #1b2a4e; background: #eef1f7;
}
.rt-table .r { text-align: right; }
.rt-table .c { text-align: center; }

/* Totales */
.rt-totals {
  margin-left: auto; width: 320px; margin-top: 14px;
  border: 1px solid #e7e9ef; border-radius: 8px; overflow: hidden;
}
.rt-totline {
  display: flex; justify-content: space-between; align-items: center;
  padding: 8px 14px; font-size: 13px; border-bottom: 1px solid #eef0f4;
}
.rt-totline:last-child { border-bottom: 0; }
.rt-totline strong { font-size: 15px; color: #1b2a4e; }
.rt-pendiente { background: #fff6f4; }
.rt-pendiente span, .rt-pendiente strong { color: #c0392b; }

.rt-letras { margin-top: 16px; font-size: 13px; }
.rt-nota {
  margin-top: 10px; font-size: 11px; color: #6b7280; text-align: justify;
  background: #f7f9fc; border-left: 3px solid #c5a253; padding: 10px 12px; border-radius: 4px;
}
.rt-footer {
  margin-top: 22px; text-align: center; color: #8a909c; font-size: 11px;
  border-top: 1px solid #e7e9ef; padding-top: 10px;
}

@media print {
  .rt, .rt * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
</style>
